import * as React from "react";

const StockAvailable: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
            <g fill="none" fill-rule="evenodd">
                <g fill="#007C38">
                    <g transform="translate(-736 -940) translate(716 924)">
                        <circle cx="25" cy="21" r="5" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(StockAvailable);
